module.exports = __webpack_public_path__ + "static/media/Recognize1.2b289740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dental Health/Recognize1.png
// module id = 310
// module chunks = 0